import { call, put, takeLatest, delay } from "redux-saga/effects";
import { client } from "@/core/apollo-client";
import { fetchUser, setUser, setError, logout } from "./reducer";
import { User as UserType } from "@/types";
import { GET_USER, LOGOUT_USER } from "./mutations";
import { initApp } from "@/core/app";

function* fetchUserSaga(): Generator<any, void, any> {
  try {
    yield delay(1000);
    const response = yield call([client, client.query], {
      query: GET_USER,
    });
    const user: UserType = response.data.me;
    yield put(setUser(user));
  } catch (error) {
    yield put(
      setError(error instanceof Error ? error.message : "Unknown error")
    );
    yield put(logout());
  }
}

function* logoutSaga(): Generator<any, void, any> {
  yield call([client, client.mutate], {
    mutation: LOGOUT_USER,
  });
}

function* initAppSaga(): Generator<any, void, any> {
  yield put(fetchUser());
}

export function* userSaga() {
  // yield takeLatest(initApp.type, initAppSaga);
  yield takeLatest(fetchUser.type, fetchUserSaga);
  yield takeLatest(logout.type, logoutSaga);
}
